



import React, {useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {GripVertical,X,Plus,ChevronDown,ChevronUp} from 'lucide-react';

  
import FAQProductAddMoreAnswer from "./FAQProductAddMoreAnswer";
const FAQsProductAddMore=({index ,
    FAQs,id,onRemove,changeItemFAQ})=>{
  const dispatch = useDispatch();  
  const handleMouseEnter = () =>dispatch({
    type: "CURSOR",
    
    payload:true
  });
  const handleMouseLeave = () => dispatch({
    type: "CURSOR",
    
    payload:false
  });
    const [itemFAQ, setItemFAQ] = useState(FAQs?FAQs:[{question:"",answers:[{ no:1, id: generateTimestamp()
        ,answer:"" }]}]); 
  

    const [itemArrAnswer, setItemArrAnswer] = useState(FAQs?.answers?FAQs?.answers:[{ no:1, id: generateTimestamp()
        ,answer:"" }]);


    
     useEffect(()=>{ 
     },[])


     function generateTimestamp() {
        return Math.floor(Date.now() / 1000);
      }

      const removeItem = (idk) => {
        const filteredItems = itemArrAnswer.filter(item => item.id !== idk);
        setItemArrAnswer(filteredItems);
        changeItemFAQ(id,{question:itemFAQ?.question,answers:filteredItems});
       
      };
      const updateItemAnswer = (idk, answer) => {


        const updatedItems = itemArrAnswer.map(item =>
          item.id === idk ? { ...item, answer :answer } : item
        
        ); 
        setItemArrAnswer(updatedItems);
         console.log(updatedItems)
         //setItemFAQ()
         changeItemFAQ(id,{question:itemFAQ?.question,answers:updatedItems});
      
      };
     
    const flattenedData = itemArrAnswer!=[]?Object.values(itemArrAnswer):'';

     const [text, setText] = useState("");
     const [wordCount, setWordCount] = useState(0);
     const [answerStatus, setAnswerStatus] = useState(true);
     
     const handleChange = (event) => {
       const inputText = event.target.value;
       const words = inputText.trim().split(/\s+/); // Split by spaces, ignoring extra spaces
       const count = words[0] === "" ? 0 : words.length; // Handle empty input edge case
   
       if (count <= 50) {
         setText(inputText);
         setWordCount(count);
       }
     };

     const updateItemFAQ = (FAQ) => {
        console.log(FAQ)
        const updatedItems = {question:FAQ,answers:itemArrAnswer} 
        changeItemFAQ(id,updatedItems);
        setItemFAQ(updatedItems)
        return(itemFAQ);
      
      };
   return(<><div 
   
   
   style={{padding:"5px",margin:"5px",marginTop:"20px",borderRadius:"10px",background:"#fff",
   boxShadow: "0 7px 20px 0 rgba(48, 25, 131, 0.053)",border:"0px solid rgba(144, 202, 249,1)"}}> 
   
{/* <h3 style={{paddingLeft:"25px",}}   >     <span className="coloredTextV1" > Add FAQs {index+1}  </span> </h3> */}
   
     <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} style={{width:"30px",height:"30px",cursor:"pointer",float:"right",borderRadius:"50%",
    margin:"10px", marginTop:"20px",
      background:"#958FDA"}} onClick={()=>{onRemove(id);}}><X  style={{margin:"6px"}} color="#ffffff" size={18}/></div>
    {answerStatus?
 <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} style={{width:"30px",height:"30px",cursor:"pointer",float:"right",borderRadius:"50%",
    margin:"10px", marginTop:"20px",
      background:"#958FDA"}} onClick={()=>{setAnswerStatus(false);}}><ChevronUp  style={{margin:"6px"}} color="#ffffff" size={18}/></div>
    :<div onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave} style={{width:"30px",height:"30px",cursor:"pointer",float:"right",borderRadius:"50%",
   margin:"10px", marginTop:"20px",
     background:"#958FDA"}} onClick={()=>{setAnswerStatus(true);}}><ChevronDown  style={{margin:"6px"}} color="#ffffff" size={18}/></div>
    }
<div  style={{}}><div style={{}}>
    
    
    </div> 
    <div>
    <div className="" style={{height:"130px",}} > 
    
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  style={{width:"50px",height:"50px",
      borderRadius:"50%",
        float:"left",alignContent:"center",textAlign:"center",padding:"5px"}}>
          <GripVertical color="#958FDA" size={32} />
          </div>  
        {<textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}   cols={2} rows={2} value={itemFAQ?.question?(itemFAQ?.question):"Q"+(index+1)+": "} type="text"
     placeholder={(index+1)+": Add FAQ "+(index+1)}
        onChange={(e)=>{handleChange(e);changeItemFAQ(id,updateItemFAQ(e.target.value));}}
        style={{minWidth:"150px",marginBottom:"30px",background:"#f5f5f5",border:"0px solid rgba(144, 202, 249,1)"}}  className="inputTextCardFAQ"></textarea>}</div>
 
     {answerStatus?flattenedData?flattenedData.map((item, index) => 
        (<div  index={index} key={item.id}  >
            <div className={"posRelative"  } >
                <FAQProductAddMoreAnswer index={index} key={item.id} 
        
            answer={item}  id={item.id} 
           changeItemAnswer={(id,answer)=>{updateItemAnswer(id,answer); }}
           
            onRemove={removeItem} />
          </div>
          
          </div>)):'' :""}
         {answerStatus? <div align="center">
<div align="center"  style={{width:"240px",
     }}> 
      <div onClick={()=>setItemArrAnswer([...itemArrAnswer, 
        {no: itemArrAnswer.length+1, id: generateTimestamp()+2
      ,  answer:"" }])} onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} className="" 
     style={{margin:"5px",marginTop:"20px",padding:"10px",cursor:"pointer",color:"#ffffff",fontSize:"16px",fontWeight:"bold",background:"rgba(144, 202, 249,1)",borderRadius:"10px"}}>+ Add Answer</div>
      
           </div>
    </div>:""}
    </div>
    
    </div>
    
    </div></>)
}  

export default FAQsProductAddMore;
